
import './VActiveControl.scss';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
class VInput extends Vue {
    @Prop({ type: [String, Number, Boolean], default: '' })
    value!: string | number | boolean;

    get listeners() {
        this.$listeners.input = this.onInput;

        return this.$listeners;
    }

    @Emit('input')
    onInput(event: InputEvent): string {
        return (event.target as HTMLInputElement).value;
    }
}

export default VInput;
